import axios from '@/api/config';

const polyv = {
    getChannel(data) {
      return axios.get(`${process.env.BASE_URL}/polyv/getChannel`, {params: data});
    },
    createChannel(data) {
      return axios.post(`${process.env.BASE_URL}/polyv/createChannel`, data);
    },
    pageList(data) {
      return axios.post(`${process.env.BASE_URL}/polyv/pageList`, data);
    },
    liveLikes(data) {
      return axios.get(`${process.env.BASE_URL}/polyv/liveLikes`, {params: data});
    },
}

export default polyv;



// WEBPACK FOOTER //
// ./src/api/polyv.js